
/**
 * @deprecated Use hooks from src/hooks/putting/ instead
 * This file is kept for backward compatibility
 */

import { usePelzResults, useTrainingResults } from './putting';

/**
 * Hook for fetching and managing Pelz test results only
 * (from /putting and /approaches pages)
 * @deprecated Use usePelzResults from src/hooks/putting/ instead
 */
export const usePuttingResults = usePelzResults;

/**
 * Hook for fetching and managing training test results only
 * (from the training pages, with levels)
 * @deprecated Use useTrainingResults from src/hooks/putting/ instead
 */
export { useTrainingResults };
